"use client";
import Image from "next/image";
import { useRef, useState } from "react";

const images = [
  "/assets/elements/mb-1.png",
  "/assets/elements/mb-2.png",
  "/assets/elements/mb-3.png",
  "/assets/elements/mb-4.png",
];

export default function StepforMatchingMobile({ steps }) {
  const scrollRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const startX = useRef(0);
  const scrollStart = useRef(0);

  // 捲動到指定 index
  const scrollToIndex = (index) => {
    const container = scrollRef.current;
    const items = container.children;
    if (index < 0 || index >= items.length) return;
    // 計算要捲到的位置
    const targetLeft =
      items[index].offsetLeft -
      (container.offsetWidth - items[index].offsetWidth) / 2;

    container.scrollLeft = targetLeft;
    setCurrentIndex(index);
  };

  // 觸控開始
  const handleTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
    scrollStart.current = scrollRef.current.scrollLeft;
  };

  // 觸控結束
  const handleTouchEnd = (e) => {
    const deltaX = e.changedTouches[0].clientX - startX.current;

    if (Math.abs(deltaX) > 60) {
      // 往左滑 → 下一張
      if (deltaX < 0) {
        scrollToIndex(currentIndex + 1);
      }
      // 往右滑 → 上一張
      else {
        scrollToIndex(currentIndex - 1);
      }
    }
  };

  return (
    <div className="steps-swiper-mb">
      <ul
        ref={scrollRef}
        className="flex overflow-x-auto snap-x snap-mandatory scroll-smooth "
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        {steps.map((step, i) => (
          <li key={step.id} className="snap-center shrink-0 w-[280px]">
            <figure>
              <Image
                src={images[i]}
                width={300}
                height={300}
                alt={step.title}
              />
            </figure>
            <div className="px-5">
              <h6>{step.title}</h6>
              <p>{step.content}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
